
import Vue from 'vue'
import TextBlock from '../text-block/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'
import BusinessCard from '~/components/cards/business-card.vue'

export default Vue.extend({
  name: 'PageTextBlock',
  components: { TextBlock, BusinessCard },
  mixins: [staticBlockMixin],

  props: {
    reverse: {
      type: Boolean,
      default: false
    }
  }
})
